import React, {useEffect, useState} from "react";
import { Star, Calendar } from "lucide-react";
import Button from "../ui/Button";
import Slider from "../ui/Slider";
import { Link } from "react-router-dom";
import axios from "axios";
import { formatDistanceToNow } from "date-fns";
import { host } from "../../api/ApiCalls";
import RecommendedTeachersSkeleton from "../skeleton/RecommendedTeachersSkeleton";




const RecommendedTeachers = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${host}/api/teachers/recommended`)
      .then(res => setTeachers(res.data.teachers))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <RecommendedTeachersSkeleton />;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Top-Rated Teachers</h2>
          <p className="text-xl text-gray-600">
            Learn from the best in your field
          </p>
        </div>

        <Slider>
          {teachers.map((t) => (
            <div key={t._id} className="min-w-[320px] md:min-w-[360px] flex-shrink-0">
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-shadow p-6 border border-gray-100 flex flex-col h-full">
                <div className="flex items-center space-x-4 mb-4">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-20 h-20 rounded-full object-cover border-2 border-indigo-500"
                  />
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800">{t.name}</h3>
                    <div className="flex items-center gap-1 text-yellow-400">
                      <Star className="h-5 w-5 fill-current" />
                      <span className="text-sm font-medium">{t.rating.toFixed(1)}</span>
                    </div>
                  </div>
                </div>

                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {t.bio}
                </p>

                <div className="text-gray-500 text-sm mb-4 space-y-1">
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4 text-indigo-500" />
                    Joined {formatDistanceToNow(new Date(t.createdAt), { addSuffix: true })}
                  </div>
                  <div>
                    🎓 {t.offeredCourses?.length || 0} course
                    {t.offeredCourses?.length !== 1 && 's'} offered
                  </div>
                </div>

                <div className="mt-auto">
                  <Link to={`/teachers/${t._id}`}>
                    <Button size="sm">View Profile</Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}

          {/* Show More */}
          <div className="min-w-[320px] md:min-w-[360px] flex-shrink-0 flex justify-center items-center">
            <Link to="/teachers" className="group w-full h-full flex justify-center items-center border-2 border-dashed border-indigo-300 rounded-2xl hover:bg-indigo-50 transition">
              <div className="flex flex-col items-center">
                <span className="text-indigo-600 group-hover:text-indigo-800 text-4xl">
                  →
                </span>
                <span className="text-gray-500 group-hover:text-gray-800 text-sm mt-2">
                  Show More
                </span>
              </div>
            </Link>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default RecommendedTeachers;
